export default __webpack_public_path__ + "static/SRF 0115PW - Product Specifications & Technical Data-177204e184c66389eb8a7c3af77b1c19.pdf";